module.exports = __webpack_public_path__ + "static/media/servicio2.92267693.jpeg";